// Clinic Configuration for Dentist in Bowie
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist in Bowie",
  clinicId: "dentistinbowie",
  clinicUrl: "https://dentistinbowie.com",
  // Contact Information
  phoneNumber: "(301) 880-0504",
  phoneNumberRaw: "+13018800504", // For tel: and sms: links
  email: "dentalcare@dentistinbowie.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinbowie&agentId=2f7b168c-4652-4eda-88b3-1e1c0458e716",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinbowie/voice",

  // Location
  address: "14999 Health Center Dr #110, Bowie, MD 20716, United States",
  addressShort: "14999 Health Center Dr #110, Bowie, MD 20716",
  city: "Bowie",
  hcity: "Bowie",
  state: "Maryland",
  stateShortForm: "MD",
  PostalCode: "20716",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/JBRGBWEGpaUxgp969",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d89860.8097569583!2d-76.8315917!3d38.9443816!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7ebf21b24023b%3A0xa37eaac092ffc6df!2sDentist%20in%20Bowie!5e1!3m2!1sen!2sin!4v1759820043573!5m2!1sen!2sin',
  iframeTitle: "Dentist in Bowie",

  //membership
  membership: "https://member.kleer.com/?slug=TL2J",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/DentistinBowie",

  // Cherry
  cherryUrl: "https://dentistinbowie.com/patient-portal",

  // Analytics
  gaMeasurementId: "G-LCN8KCN3HJ",
  clarityProjectId: "prctr500z6",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinbowie",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinbowie",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinbowie",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://dentistinbowie.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/DentistinBowie",
    instagram: "https://www.instagram.com/dentistinbowie/",
    twitter: "https://x.com/BowieDental1",
    linkedin: "https://www.linkedin.com/company/dentist-in-bowie/",
    youtube: "https://www.youtube.com/@dentistinbowie",
  },

  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/5875815609353747966/profile?hl=en-GB&fid=11781041419324475103",
    facebook: "https://www.facebook.com/DentistinBowie",
    yelp: "https://www.yelp.com/biz/dentist-in-bowie-bowie",
  },

  // Open Dental Configuration
  defaultProvNum: 3,
  defaultOpNum: 20,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: "New patient emergency/other",
      label: "New patient emergency/other",
      duration: 30,
      opNum: 21,
      AppointmentTypeNum: 5,
    },
    {
      value: "Existing patient emergency/other",
      label: "Existing patient emergency/other",
      duration: 30,
      opNum: 20, // DEFAULT_OP_NUM
      AppointmentTypeNum: 3,
    },
    {
      value: "Existing patient current treatment Plan",
      label: "Existing patient current treatment Plan",
      duration: 30,
      opNum: 20, // DEFAULT_OP_NUM
      AppointmentTypeNum: 16,
    },
  ],


  // Twilio Configuration
  twilioPhoneNumber: "13018723843",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  membership,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;
